module.exports = __webpack_public_path__ + "static/media/icon-check-single.9832334f.svg";